import { axiosInstanceMain } from '../../../utils/axiosGlobalUtils'
import { hash } from '../../../utils/hashFunction'
import { ITenant } from '../../AbmLocalPage/types'
import { flattenRubrosHierarchy } from '../../Products/hooks/rubros.hook'

export const getAllRubros = async (tenant: ITenant, deviceId: string) =>
  await axiosInstanceMain.get(
    `/${tenant.path}/rubros?incluir-atributos=true&deviceId=${deviceId}&clave=347ebc28653419c788302d8eba55b75a`
  )
export const handleNewRubro = async (codProducto: string, codRubro: string, tenant: ITenant) =>
  await axiosInstanceMain.patch(`/admin/${tenant.path}/productos/${codProducto}/rubro`, {
    valor: codRubro
  })

export const findRubro = (codRubro: string | number, rubros: any) => {
  const flatten = flattenRubrosHierarchy(rubros)
  let rubroEncontrado: any
  flatten.forEach((r: any) => {
    if (r.rubros) {
      r.rubros.forEach((j: any) => {
        if (j.rubros) {
          j.rubros.forEach((k: any) => {
            if (k.codRubro === codRubro) {
              rubroEncontrado = k
              return k
            }
          })
        } else {
          if (j.codRubro === codRubro) {
            rubroEncontrado = j
            return j
          }
        }
      })
    } else {
      if (r.codRubro === codRubro) {
        rubroEncontrado = r
        return r
      }
    }
  })

  return rubroEncontrado
}

export const findUnidadDeMedida = (idUnidadDeMedida: number | string, codRubro: string | number, rubros: any) => {
  if (!rubros) return null

  const rubro = findRubro(codRubro, rubros)

  let unidadDeMedidaEncontrada = null

  if (rubro?.unidadDeMedidaList?.length > 1) {
    unidadDeMedidaEncontrada = rubro.unidadDeMedidaList.find((u: any) => {
      return u.idUnidadDeMedida === idUnidadDeMedida
    })
  } else {
    unidadDeMedidaEncontrada = rubro?.unidadDeMedidaList[0]
  }

  return unidadDeMedidaEncontrada
}

export const getFotosEntrenamiento = async (tenant: ITenant, codRubro: string, pagina: number, cantxpagina: number) => {
  const page = pagina === 0 ? pagina + 1 : pagina
  const params = new URLSearchParams({
    pagina: page.toString(),
    cantxpagina: cantxpagina.toString()
  })

  if (codRubro) {
    params.append('codRubro', codRubro.toString())
  }

  return await axiosInstanceMain.get(`/admin/${tenant.path}/rubros/ia-entrenamiento?${params}`)
}

export const updateFotosEntrenamiento = async (tenant: ITenant, idFoto: number, codRubros: string[]) =>
  await axiosInstanceMain.patch(`/admin/${tenant.path}/rubros/ia-entrenamiento/${idFoto}`, { codRubros: codRubros })

export const borrarFotoEntrenamiento = async (tenant: ITenant, idFoto: number) =>
  axiosInstanceMain.delete(`/admin/${tenant.path}/rubros/ia-entrenamiento/${idFoto}`)

export const uploadFotoEntrenamiento = async (tenant: ITenant, filename: string, foto: string, codRubros: string[]) =>
  await axiosInstanceMain.post(`/admin/${tenant.path}/rubros/ia-entrenamiento`, {
    imagenBase64: foto,
    filename: filename,
    codRubros: codRubros
  })

export const entrenarModelo = async (tenant: ITenant) =>
  await axiosInstanceMain.post(`/admin/${tenant.path}/rubros/ia-entrenamiento/entrenar-modelo`)

export const statusEntrenamiento = async (tenant: ITenant) =>
  await axiosInstanceMain.get(`/admin/${tenant.path}/rubros/ia-entrenamiento/status-last-job`)

export const prediccionRubro = async (tenant: ITenant, payload: any, clave: string) =>
  await axiosInstanceMain.post(`/${tenant.path}/rubros/prediccion-desde-imagen?clave=${clave}`, payload, {
    headers: {
      'Content-Type': 'application/json'
    }
  })

export const getAtributos = async (tenant: ITenant, deviceId) => {
  const clave = await hash(deviceId + 'lugares2017')
  return await axiosInstanceMain.get(`/${tenant.path}/rubros/atributos?deviceId=${deviceId}&clave=${clave}`)
}
